<template>
    <component :is="template">
        <div>
            <v-row>
                <v-col>
                    <div class="order-content">
                        <v-card tile elevation="0" class="px-12px py-20px pa-md-50px">
                            <div class="tit-wrap tit-wrap--unberline">
                                <h2 class="tit">주문하기</h2>
                            </div>

                            <section class="page-section pt-0">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="tit tit--xs">구매자 정보 입력</h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <div>
                                    <v-row align="center" class="row--x-small">
                                        <v-col cols="12">
                                            <v-text-field v-model="order.buyer.name" placeholder="이름" outlined persistent-placeholder hide-details/>
                                        </v-col>
                                        <v-col cols="12">
                                            <div class="w-100 mw-500px">
                                                <v-row align="center" class="row--x-small">
                                                    <v-col>
                                                        <v-select v-model="order.buyer.phone1" v-bind="$attrs" :items="phones" placeholder="연락처" outlined persistent-placeholder hide-details />
                                                    </v-col>
                                                    <v-col cols="auto">-</v-col>
                                                    <v-col>
                                                        <v-text-field v-model="order.buyer.phone2" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()"/>
                                                    </v-col>
                                                    <v-col cols="auto">-</v-col>
                                                    <v-col>
                                                        <v-text-field v-model="order.buyer.phone3" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()"/>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="order.buyer.email" placeholder="이메일" outlined persistent-placeholder hide-details />
                                        </v-col>
                                    </v-row>
                                </div>
                            </section>

                            <template v-if="!carts.find(cart => cart.product.type == `ebook`)">
                                <section class="page-section">
                                    <div class="mb-10px mb-md-20px">
                                        <h3 class="tit tit--xs">수취인 정보 입력</h3>
                                        <v-divider class="grey lighten-1 mt-10px"/>
                                    </div>
    
                                    <div>
                                        <v-row align="center" class="row--x-small">
                                            <v-col cols="12">
                                                <v-text-field v-model="order.receiver.name" placeholder="이름" outlined persistent-placeholder hide-details/>
                                            </v-col>
                                            <v-col cols="12">
                                                <div class="w-100 mw-500px">
                                                    <v-row align="center" class="row--x-small">
                                                        <v-col>
                                                            <v-select v-model="order.receiver.phone1" v-bind="$attrs" :items="phones" placeholder="연락처" outlined persistent-placeholder hide-details @click="$refs.kcpCert.open()" />
                                                        </v-col>
                                                        <v-col cols="auto">-</v-col>
                                                        <v-col>
                                                            <v-text-field v-model="order.receiver.phone2" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()"/>
                                                        </v-col>
                                                        <v-col cols="auto">-</v-col>
                                                        <v-col>
                                                            <v-text-field v-model="order.receiver.phone3" v-bind="$attrs" outlined hide-details maxlength="4" @click="$refs.kcpCert.open()"/>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field v-model="order.receiver.email" placeholder="이메일" outlined persistent-placeholder hide-details />
                                            </v-col>
                                            <v-col cols="12">
                                                <div class="w-100 mw-500px">
                                                    <v-row align="center" class="row--x-small">
                                                        <v-col>
                                                            <v-text-field v-model="order.shippingAddress.postcode" v-bind="$attrs" placeholder="우편번호" outlined persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <v-btn color="primary" class="v-btn--input" @click="$refs.daumPostcode.open()">주소검색</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field v-model="order.shippingAddress.address1" v-bind="$attrs" placeholder="기본주소" outlined persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field v-model="order.shippingAddress.address2" v-bind="$attrs" placeholder="상세주소" outlined persistent-placeholder hide-details />
                                            </v-col>
                                        </v-row>
                                    </div>
                                </section>
    
                                <section class="page-section pt-0">
                                    <v-checkbox v-model="checkbox" label="구매자 정보와 동일" hide-details class="d-inline-flex ma-0"></v-checkbox>
                                </section>
                            </template>

                            <section class="page-section">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="tit tit--xs">요청사항</h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <v-textarea v-model="order.demand" placeholder="배송요청사항" outlined persistent-placeholder rows="3" hide-details/>
                            </section>

                            <section class="page-section">
                                <v-divider class="grey darken-4"/>
                                <template v-for="cart, index in carts">
                                    <v-divider v-if="index" />
                                    <pickup-item :key="cart._id" :cart="cart" />
                                </template>
                                <v-divider/>
                            </section>

                            <section v-if="me" class="page-section">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="d-flex flex-wrap align-center tit tit--xs">
                                        <span class="mr-8px">포인트</span>
                                        <span class="font-size-14 font-weight-regular">(포인트는 500원부터 사용이 가능합니다)</span>
                                    </h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <div>
                                    <v-row align="center" class="row--small">
                                        <v-col cols="12">
                                            <div class="d-inline-flex align-center font-size-14 line-height-1">
                                                <span class="mr-8px">보유포인트</span>
                                                <b class="font-size-18 font-size-md-22">{{ me.point.format() }}</b>
                                                <span class="ml-2px">원</span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row align="center" class="row--x-small">
                                                <v-col cols="auto">
                                                    <v-text-field v-model="order.pointAmount" placeholder="포인트 사용" suffix="원" persistent-placeholder outlined hide-details @input="value => $nextTick(_ => changePoint(value))" />
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-btn color="primary" class="v-btn--input" @click="usePoint">전체사용</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                            </section>

                            <section v-if="me" class="page-section">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="d-flex flex-wrap align-center tit tit--xs">
                                        <span class="mr-8px">캐시</span>
                                        <span class="font-size-14 font-weight-regular">(캐시는 100원부터 사용이 가능합니다)</span>
                                    </h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <div>
                                    <v-row align="center" class="row--small">
                                        <v-col cols="12">
                                            <div class="d-inline-flex align-center font-size-14 line-height-1">
                                                <span class="mr-8px">보유캐시</span>
                                                <b class="font-size-18 font-size-md-22">{{ me.cash.format() }}</b>
                                                <span class="ml-2px">원</span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row align="center" class="row--x-small">
                                                <v-col cols="auto">
                                                    <v-text-field v-model="order.cashAmount" placeholder="캐시 사용" suffix="원" persistent-placeholder outlined hide-details @input="value => $nextTick(_ => changeCash(value))"/>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-btn color="primary" class="v-btn--input" @click="useCash">전체사용</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                            </section>

                            <section class="page-section pb-0">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="tit tit--xs">결제방법</h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <div>
                                    <div class="d-inline-flex flex-wrap align-center font-size-14 line-height-1">
                                        <v-checkbox v-model="cardCheck" :value="true" hide-details label="신용카드" class="ma-0"></v-checkbox>
                                        <span class="font-size-14 line-height-14 ml-6px">(나누리 캐시 또는 포인트 사용시 결제 금액 입력후 신용카드 선택 결제 할 수 있습니다.)</span>
                                    </div>
                                    <!-- <toss-pay v-if="totalAmount" :paymentAmount="totalAmount" ref="tossPay"/> -->
                                </div>
                            </section>

                            <section v-if="cashbill" class="page-section pb-0">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="tit tit--xs">현금영수증<v-icon @click="$refs.cashbillInfo.open()">mdi-help-circle</v-icon></h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <div>
                                    <div class="d-inline-flex flex-wrap align-center font-size-14 line-height-1">
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col>
                                                    <v-checkbox v-model="order.cashbill.status" :value="true" hide-details label="현금영수증 신청" class="ma-0"></v-checkbox>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-radio-group v-model="order.cashbill.tradeUsage" :disabled="!order.cashbill.status">
                                                            <v-radio label="개인 소득 공제" value="소득공제용"></v-radio>
                                                            <v-radio label="사업자 지출 증빙" value="지출증빙용"></v-radio>
                                                    </v-radio-group>
                                                    <v-select v-if="order.cashbill.tradeUsage === '소득공제용'" v-model="cashbillType" :disabled="!order.cashbill.status" :items="items" outlined persistent-placeholder hide-details />
                                                    <v-text-field v-model="order.cashbill.identityNum" :placeholder="displayCashbillPlaceholder" :disabled="!order.cashbill.status" outlined persistent-placeholder hide-details></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </div>
                                </div>
                            </section>

                            <!-- <section class="page-section pb-0">
                                <div class="mb-10px mb-md-20px">
                                    <h3 class="tit tit--xs">도서소득 공제<v-icon @click="$refs.incomeDeduction.open()">mdi-help-circle</v-icon></h3>
                                    <v-divider class="grey lighten-1 mt-10px"/>
                                </div>

                                <div>
                                    <ul class="d-inline-flex flex-wrap align-center font-size-14 line-height-1">
                                        <li>
                                            카드결제는 카드 명의자 기준으로, 현금결제는 개인공제용으로 현금영수증 신청한 기준으로 국세청에 자동 반영됩니다.
                                        </li>
                                    </ul>
                                </div>
                            </section> -->
                        </v-card>

                        <div v-if="$vuetify.breakpoint.mobile" class="card--primary mt-10px mt-md-20px">
                            <v-row align="center" justify="center" class="row--x-small font-size-14 font-size-md-16">
                                <v-col cols="auto">
                                    <span>총 상품가격(<b>{{ saleAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">+</v-col>
                                <v-col cols="auto">
                                    <span>총 배송비(<b>{{ shippingAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col v-if="islandAmount" cols="auto">+</v-col>
                                <v-col v-if="islandAmount" cols="auto">
                                    <span>도서산간 할증(<b>{{ islandAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col cols="auto">
                                    <span>사용 포인트(<b>{{ (+order.pointAmount).format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col cols="auto">
                                    <span>사용 캐시(<b>{{ (+order.cashAmount).format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">=</v-col>
                                <v-col cols="auto">
                                    <div class="d-flex align-center">
                                        <span>총 결제 금액</span><b class="font-size-20 font-size-md-24 ml-10px ml-md-12px">{{ totalAmount.format() }}원</b>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="auto">
                    <div class="quick-order-wrap">
                        <v-card tile elevation="0" width="376" class="quick-order pa-12px pa-md-30px">
                            <div class="quick-order-info">
                                <div class="quick-order-info-item">
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">총 상품가격</v-col>
                                        <v-col cols="9" md="8">
                                            {{ saleAmount.format() }}원
                                        </v-col>
                                    </v-row>
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">배송비</v-col>
                                        <v-col cols="9" md="8">
                                            {{ shippingAmount.format() }}원
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="islandAmount" align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">도서산간 할증</v-col>
                                        <v-col cols="9" md="8">
                                            {{ islandAmount.format() }}원
                                        </v-col>
                                    </v-row>
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">사용 포인트</v-col>
                                        <v-col cols="9" md="8">
                                            -{{ (+order.pointAmount).format() }}원
                                        </v-col>
                                    </v-row>
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">사용 캐시</v-col>
                                        <v-col cols="9" md="8">
                                            -{{ (+order.cashAmount).format() }}원
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="quick-order-info-total font-weight-medium">
                                    <v-divider class="my-10px" />
                                    <v-row align="center" class="row--small font-size-14">
                                        <v-col cols="3" md="4">총 결제금액</v-col>
                                        <v-col cols="9" md="8">
                                            <div class="d-flex align-center">
                                                <b class="font-size-18 font-size-md-22 secondary--text">{{ totalAmount.format() }}</b><span class="ml-2px">원</span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>

                            <div class="quick-order-button mt-10px">
                                <v-row class="row--x-small">
                                    <v-col cols="12">
                                        <v-btn @click="pay" block large color="primary" :disabled="display">결제하기</v-btn>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn to="/mypage/shop/carts" block large outlined color="grey"><span class="grey--text text--darken-3">장바구니</span></v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                    </div>
                </v-col>
            </v-row>
        </div>

        <!-- <v-card tile elevation="0" class="mt-4">
            <v-card-title class="tit tit--xs">배송지 정보 입력</v-card-title>
            <v-card-text>
                <v-row align="center">
                    <v-col cols="12" md="6" >
                        <v-text-field v-model="order.shippingAddress.postcode" v-bind="$attrs" label="우편번호" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                    </v-col>
                </v-row>
                <v-row class="mx-n3">
                    <v-col cols="12" md="6" :class="{ 'pb-0': $vuetify.breakpoint.mobile }">
                        <v-text-field v-model="order.shippingAddress.address1" v-bind="$attrs" label="기본주소" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="order.shippingAddress.address2" v-bind="$attrs" label="상세주소" persistent-placeholder hide-details />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card> -->

        <div class="mt-20px mt-md-30px">
            <v-row align="center" justify="center" class="row--x-small">
                <v-col cols="auto">
                    <v-btn @click="pay" x-large color="primary" :disabled="display">결제하기</v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn @click="$router.go(-1)" x-large outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">취소하기</span></v-btn>
                </v-col>
            </v-row>
        </div>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { order.shippingAddress.postcode = postcode; order.shippingAddress.address1 = address; } " />
        <!-- <kcp-pay ref="kcpPay" /> -->
        <!-- <nice-pay ref="nicePay" /> -->
        <korpay ref="korpay" @complete="payload => $router.push({ path: `/shop/result`, query: payload })" @close="() => (display = false)"/>
        <cashbill-info-dialog ref="cashbillInfo"/>
        <income-deduction-dialog ref="incomeDeduction"/>
    </component>
</template>
<script>
import api from "@/api";
import islands from "@/assets/data/islands.json";
import { mdiReceipt, mdiBookOpenPageVariant } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import KcpPay from "@/components/plugins/kcp/kcp-pay.vue";
import NicePay from "@/components/plugins/nice/nice-pay.vue";
import Korpay from "@/components/plugins/korpay/korpay.vue";
import TossPay from "@/components/plugins/toss/toss-pay.vue";
import cashbillInfoDialog from "@/components/client/shop/order/cashbill-info-dialog.vue"
import incomeDeductionDialog from "@/components/client/shop/order/income-deduction-dialog.vue"
export default {
    components: {
        PickupItem,
        DaumPostcode,
        cashbillInfoDialog,
        incomeDeductionDialog,
        KcpPay,
        NicePay,
        Korpay,
        TossPay
    },
    data(){
        return {
            islands,
            mdiReceipt,
            mdiBookOpenPageVariant,

            me: null,
            cashAmount: 0,

            cardCheck: true,

            order: {
                _id: null,
                pickups: [],

                buyer: {
                    _id: null,
                    name: null,

                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,

                    email: null,
                },

                receiver: {
                    name: null,

                    phone:  null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,

                    email: null,
                },

                shippingAddress: {
                    postcode: null,
                    address1: null,
                    address2: null
                },

                demand: '',
                shippingAmount:0,
                pointAmount: 0,
                cashAmount: 0,

                cashbill: {
                    status: false,
                    tradeUsage: "소득공제용",
                    identityNum: null,
                }
            },

            carts: [],

            phones: ["010", "011", "016", "017", "019"],

            setting: null,

            checkbox: false,

            tradeUsage : "소득공제용",

            items: [
                { text: "휴대폰 번호", value: "휴대폰번호"},
                { text: "현금영수증 카드번호", value: "카드번호"},
            ],
            
            cashbillType: "휴대폰번호",

            display: false
        }
    },
    async mounted(){
        await this.init();
        this.$nextTick(_ => {
                const content = document.querySelector('.order-content');
                const wing = document.querySelector('.quick-order-wrap');

                const contentTop = content.getBoundingClientRect().top + window.scrollY;

                window.addEventListener('scroll', function(){
                if(window.scrollY >= contentTop){
                    wing.classList.add('fixed');
                }else{
                    wing.classList.remove('fixed');
                }
            });
        });
        // this.$refs.tossPay.paymentAmount = this.totalAmount;

        // this.$refs.tossPay.init();
    },
    methods: {
        async init(){
            // 쇼핑몰 설정정보
            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;

            // 상품페이지 & 장바구니에서 픽업된 상품 로드
            let carts = this.$store.state.pickupItems;
            if(!carts.length){
                alert("구매하실 상품을 선택해주세요");
                this.$router.go(-1);
                return;
            }
            else if(!this.logon && carts.find(cart => cart.product.type == "ebook")){
                alert("ebook 상품은 로그인 회원만 구매가능합니다.");
                this.$router.go(-1);
                return;
            }
            this.$store.dispatch("checkout");

            this.carts = carts;
            this.order.pickups = carts.map(cart => ({ _product: cart.product._id, quantity: cart.quantity }));

            if(this.logon){
                let { me } = await api.v1.me.profile.get();
                let { _id, name, username, phone, email, postcode, address1, address2  } = me;
                let [ phone1, phone2, phone3 ] = phone?.phoneNumberFormat?.()?.split?.('-') || [];

                this.$set(this.$data, "me", me);

                this.$set(this.order, "buyer", {
                    _id,
                    name,
                    username,
                    phone, phone1, phone2, phone3,
                    email
                });

                if(carts.find(cart => cart.product.type == "ebook")){
                    this.$set(this.order, "receiver", {
                        name,
                        phone1, phone2, phone3,
                        email
                    });

                    this.$set(this.order, "shippingAddress", {
                        postcode,
                        address1,
                        address2,
                    });
                }
            }
        },

        useCash(){
            this.changeCash(this.me.cash);
        },

        changeCash(cashAmount){
            cashAmount = cashAmount?.replace?.(/[^0-9]/g, '') ?? cashAmount;
            cashAmount = +cashAmount || 0;

            if(this.me.cash < cashAmount) cashAmount = this.me.cash;
            if(this.totalAmount + +this.order.cashAmount < cashAmount) cashAmount = this.totalAmount + +this.order.cashAmount;

            this.order.cashAmount = cashAmount;
        },

        usePoint(){
            this.changePoint(this.me.point);
        },

        changePoint(pointAmount){
            pointAmount = pointAmount?.replace?.(/[^0-9]/g, '') ?? pointAmount;
            pointAmount = +pointAmount || 0;

            if(this.me.point < pointAmount) pointAmount = this.me.point;
            if(this.totalAmount + +this.order.pointAmount < pointAmount) pointAmount = this.totalAmount + +this.order.pointAmount;

            this.order.pointAmount = pointAmount;
        },

        /**
         * @param {Object} receiver 
         * @param {String} receiver.name
         * @param {Array} receiver.phone
         * @param {String} receiver.email
         * 
         * @param {Object} shippingAddress
         * @param {String} shippingAddress.postcode
         * @param {String} shippingAddress.address1
         * @param {String} shippingAddress.address2
         */
        setReceiver(receiver, shippingAddress){
            this.$set(this.order, "receiver", {
                ...receiver,
                phone1: receiver.phone[0] || "010",
                phone2: receiver.phone[1],
                phone3: receiver.phone[2],
            });

            this.$set(this.order, "shippingAddress", shippingAddress);
        },

        async validate(){
            try{
                if(!this.order.buyer.name) throw new Error("구매자 이름을 입력해주세요");
                if(!this.order.buyer.phone) throw new Error("구매자 연락처를 입력해주세요");
                if(!this.order.buyer.email) throw new Error("구매자 이메일을 입력해주세요");

                if(!this.order.receiver.name) throw new Error("수취인 이름을 입력해주세요");
                if(!this.order.receiver.phone) throw new Error("수취인 연락처를 입력해주세요");
                if(!this.order.receiver.email) throw new Error("수취인 이메일을 입력해주세요");

                if(!this.order.shippingAddress.postcode) throw new Error("배송지 우편번호를 입력해주세요");
                if(!this.order.shippingAddress.address1) throw new Error("배송지 기본주소를 입력해주세요");
                if(!this.order.shippingAddress.address2) throw new Error("배송지 상세주소를 입력해주세요");


                if(this.order.pointAmount && this.order.pointAmount < 500) throw new Error("포인트는 500원 이상부터 사용할 수 있습니다");
                if(this.order.cashAmount && this.order.cashAmount < 100) throw new Error("캐시는는 100원 이상부터 사용할 수 있습니다");
                if(this.order.cashbill.status && !this.order.cashbill.identityNum) throw new Error("현금영수증 신청을 위한 휴대폰번호, 카드번호, 사업자번호를 확인해주세요")

                
                if(this.order.cashbill.status) {
                    return await this.$confirm(`${this.order.cashbill.identityNum}으로 현금영수증 신청을 진행하시겠습니까?`)
                }
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async pay(){
            try {
                if(await this.validate()){
                    this.display = true;
                    let { order } = await api.v1.shop.orders.post(this.order);
                    // 실결제금액이 있을때 신용카드 결제
                    if(order.paymentAmount){
                        // this.$refs.kcpPay.orderNo = order.orderNo;
                        // this.$refs.kcpPay.orderName = this.carts[0].product.name;
                        // this.$refs.kcpPay.paymentAmount = order.paymentAmount;
                        // this.$refs.kcpPay.isDeduction = order.isDeduction;
                        // this.$refs.kcpPay.pay();
    
                        // this.$refs.nicePay.amt = order.paymentAmount;
                        // this.$refs.nicePay.goodsName = this.carts[0].product.name;
                        // this.$refs.nicePay.moid = order.orderNo;
                        // this.$refs.nicePay.buyerName = order.buyer.name
                        // this.$refs.nicePay.buyerEmail = order.buyer.email
                        // this.$refs.nicePay.buyerTel = order.buyer.phone
                        // this.$refs.nicePay.nicepayStart();
                        
                        if (window.navigator.userAgent.indexOf("iPhone") > -1 || window.navigator.userAgent.indexOf("Android") > -1) {
                            if (await this.$confirm("결제사 사정으로 인하여 어플 이용 시 신용카드 결제가 불가합니다.\n캐시와 포인트를 이용해 구매하시거나 모바일 웹, PC 환경에서 카드 결제가 가능합니다.")) {
                                this.$refs.korpay.paymentAmount = order.paymentAmount;
                                this.$refs.korpay.orderNo = order.orderNo;
                                this.$refs.korpay.orderName = this.carts[0].product.name;
                                this.$refs.korpay.buyerName = order.buyer.name
                                this.$refs.korpay.open();
                            }
                        } else {
                            this.$refs.korpay.paymentAmount = order.paymentAmount;
                            this.$refs.korpay.orderNo = order.orderNo;
                            this.$refs.korpay.orderName = this.carts[0].product.name;
                            this.$refs.korpay.buyerName = order.buyer.name
                            this.$refs.korpay.open();
                        }
                        // this.$refs.tossPay.paymentAmount = order.paymentAmount
    
                        // this.$refs.tossPay.orderId = order.orderNo
                        // this.$refs.tossPay.orderName = this.carts[0].product.name
                        // this.$refs.tossPay.customerEmail = order.buyer.email
                        // this.$refs.tossPay.customerName = order.buyer.name
                        // this.$refs.tossPay.order = order
                        // this.$refs.tossPay.clickPaymentButton();
                    }
                    // 캐시·포인트 전액 지불해서 실결제금액이 없는경우 결제완료 처리
                    else{
                        let response = await api.v1.shop.orders.pay({ _id: order._id });
                        this.$router.push({
                            path: "/shop/result",
                            query: response
                        });
                    }
                }
            } catch(error) {
                console.error(error);
            }
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },

        accessToken(){
            return this.$store.state.accessToken;
        },

        logon(){
            return !!this.accessToken;
        },

        saleAmount(){
            return this.carts.reduce((saleAmount, cart) => saleAmount + cart.product.salePrice * cart.quantity, 0);
        },

        shippingAmount(){
            let pickups = this.carts;
            let shippingAmount = 0;
            let setting = this.setting;

            let freeItem = pickups.filter(el => el.product.shippingCode === "free")
            let orderItem = pickups.filter(el => el.product.shippingCode === "order")
            let selfItem = pickups.filter(el => el.product.shippingCode === "self")

            if(orderItem.length === pickups.length && orderItem.length){
                if(this.saleAmount >= setting.saleAmount){
                    this.order.shippingAmount = shippingAmount
                    return shippingAmount
                } else {
                    this.order.shippingAmount = setting.shippingPrice.lt
                    return setting.shippingPrice.lt
                }
            }

            if(freeItem.length){
                if(this.setting?.freePolicyCode === 'free') {
                    this.order.shippingAmount = shippingAmount
                    return shippingAmount
                }
            } else {
                if(this.setting?.productPolicyCode === 'product2'){
                    let max = 0
                    for(let i = 0; i < pickups.length; i++){
                        if(pickups[i].product.shippingCode === 'order'){
                            if(max < setting.shippingPrice.lt) max = setting.shippingPrice.lt
                        } else {
                            if(max < pickups[i].product.shippingPrice) max = pickups[i].product.shippingPrice
                        }
                    }
                    this.order.shippingAmount = max
                    return max
                }
            }

            // 상품 배송정책
            shippingAmount += pickups.filter(pickup => pickup.product.shippingCode == "self").reduce((shippingAmount, pickup) => +pickup.product.shippingPrice + shippingAmount, 0);

            // 주문 배송정책
            let saleAmount = pickups.filter(pickup => pickup.product.shippingCode == "order").reduce((saleAmount, pickup) => saleAmount + pickup.product.salePrice * pickup.quantity, 0);
            if(pickups.some(pickup => pickup.product.shippingCode == "order")) shippingAmount += setting.saleAmount <= saleAmount ? setting.shippingPrice.gt : setting.shippingPrice.lt;
            this.order.shippingAmount = shippingAmount
            return shippingAmount;
        },

        islandAmount(){
            let shippingAddress = this.order.shippingAddress;
            let islandAmount = 0;
            let setting = this.setting;
            let island = this.islands.find(island => {
                return island.areas.find(area => area.postcode == shippingAddress.postcode);
            });

            switch(island?.code){
                case "jeju": { islandAmount = parseInt(setting.islandPrice?.jeju || 0); break; }
                case "normal": { islandAmount = parseInt(setting.islandPrice?.normal || 0); break; }
            }

            return islandAmount;
        },

        totalAmount(){
            return this.saleAmount + this.shippingAmount + this.islandAmount - this.order.pointAmount - this.order.cashAmount;
        },

        displayCashbillPlaceholder() {
            if(this.order.cashbill.tradeUsage === "지출증빙용") {
                return "사업자등록번호를 -없이 입력해 주세요."
            } else if(this.order.cashbill.tradeUsage === "소득공제용" && this.cashbillType === "휴대폰번호") {
                return "휴대폰 번호를 입력주세요."
            } else {
                return "카드번호를 -없이 입력해 주세요."
            }
        }
    },
    watch: {
        order: {
            deep: true,
            handler(value){
                console.log({ value });
                var { phone1, phone2, phone3 } = value.buyer;
                value.buyer.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;

                var { phone1, phone2, phone3 } = value.receiver;
                value.receiver.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;
            }
        },
        checkbox: function() {
            if(!this.checkbox){
                this.setReceiver(
                    {
                        name: null,
                        phone: [],
                        email: null,
                    },
                    {
                        postcode: null,
                        address1: null,
                        address2: null
                    }
                );
            } 
            else {
                this.setReceiver(
                    {
                        name: this.me.name,
                        phone: this.me.phone?.phoneNumberFormat?.()?.split?.('-') || [],
                        email: this.me.email,
                    },
                    {
                        postcode: this.me.postcode,
                        address1: this.me.address1,
                        address2: this.me.address2
                    }
                );
            }
        },
        "totalAmount"() {
            if(this.totalAmount === 0) {
                this.cardCheck = false
                return;
            }
            this.cardCheck = true
        },
        "order.cashAmount"() {
            if(this.order.cashAmount === 0) {
                this.cashbill = false;
            } else {
                this.cashbill = true;
            }
        }
    }
}
</script>

<style scoped>
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

.quick-order-wrap{
    width: 376px;
}
.quick-order-wrap.fixed .quick-order{
    position: fixed;
    top: 0;
}
</style>
